import { render, staticRenderFns } from "./SidebarVesselEquipmentBaseStations.vue?vue&type=template&id=45c2a5ad&"
import script from "./SidebarVesselEquipmentBaseStations.vue?vue&type=script&lang=js&"
export * from "./SidebarVesselEquipmentBaseStations.vue?vue&type=script&lang=js&"
import style0 from "./SidebarVesselEquipmentBaseStations.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports